import type { Patch } from "@freightsimple/shared/types";
import { usePostalCodesApi } from "@/Hooks/usePostalCodesApi";
import type { Address } from "@freightsimple/generated-dashboard-openapi-client/models/Address";
import type { PreQuoteLocation } from "@freightsimple/generated-dashboard-openapi-client/models/PreQuoteLocation";
import { useState } from "react";
import { useOnce } from "@/Hooks/useOnce";

export function useLocationsAddressOptions(
  location: PreQuoteLocation,
  updateAddress: (addressUpdate: Patch<Address>) => void,
) {
  const [addressOptions, setAddressOptions] = useState<Array<string>>([]);
  const postalCodesApi = usePostalCodesApi();

  const postalCode = location.address.postalCode;

  useOnce(async () => {
    if (!postalCode) {
      throw new Error("Missing postalCode");
    }
    const _addressOptions = await postalCodesApi.lookUpPotentialAddresses({
      postalCode,
    });
    setAddressOptions(_addressOptions);

    if (
      _addressOptions.length === 1 &&
      (location.address.addressLine === "" ||
        location.address.addressLine === undefined)
    ) {
      updateAddress({ addressLine: _addressOptions[0] });
    }
  });

  return { addressOptions };
}
